import React from 'react';
import PropTypes from 'prop-types';

import ChildSeoLinks from '../react-child-seo-links';

import './index.scss';

const SeoInternalLinks = ({seoLinks = [], entityType = '', entityId, title = ''}) => {
  let titleEle = null;
  if (typeof title === 'string' && title !== '') {
    titleEle = <h2 className={`SeoInternalLinks__${entityType}__Title SeoInternalLinks__Title`}>{title}</h2>;
  } else if (title && title.props) {
    titleEle = title;
  }

  return seoLinks.length > 0 ? (
    <div className="SeoInternalLinks">
      {titleEle}
      <div className={`SeoInternalLinks__Links SeoInternalLinks__${entityType}__Links`}>
        <ChildSeoLinks
          entityType={entityType}
          entityId={entityId}
          seoLinks={seoLinks}
          instanceId={`${entityType}-${entityId}`}
          title=""
        />
      </div>
    </div>
  ) : null;
};

SeoInternalLinks.propTypes = {
  entityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  entityType: PropTypes.string,
  seoLinks: PropTypes.array,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default SeoInternalLinks;
